import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { SWRConfig } from 'swr';
import App from './components/App';
import { swrConfig } from 'services/swrConfig';

import { i18nReady } from './i18n';
import { installPreloadRecovery } from './utils/preloadRecovery';

// O Sentry foi substituído pelo Rollbar configurado no componente App.jsx
// Configurações como DSN e ambiente são definidas diretamente no Provider do Rollbar

installPreloadRecovery();

const root = ReactDOM.createRoot(document.getElementById('root'));

i18nReady.then(() => {
  root.render(
    <SWRConfig value={swrConfig}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </SWRConfig>
  );
});
